module.exports = __webpack_public_path__ + "h5/img/404.d5565a4e.png";